import React, { useState, useEffect } from "react";
import { 
    Box, Grid, Paper, Typography, Tabs, Tab, 
    TextField, MenuItem, Button, Chip, Avatar, 
    Drawer, IconButton, Divider, InputAdornment,
    Container
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faSearch, faFilter, faTimes, faChevronRight, 
    faHandHoldingHeart, faCheckCircle, faClock, 
    faExclamationTriangle, faCommentAlt
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { getHelpRequests, updateRequestStatus } from "../../../controllers/help/HelpController";


// Suponiendo que tienes tus servicios HTTP vinculados así:
// import { getHelpRequests, updateRequestStatus } from "../../../controllers/admin/HelpController";

export default function HelpRequestsDashboardView() {
    // Estados principales
    const [requests, setRequests] = useState([]);
    const [stats, setStats] = useState({ pending: 0, verified: 0, delivered: 0 });
    const [currentTab, setCurrentTab] = useState("pending");
    const [selectedCity, setSelectedCity] = useState("all");
    const [searchQuery, setSearchQuery] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    // Estado para el panel lateral de detalle
    const [selectedRequest, setSelectedRequest] = useState(null);
    const [internalNotes, setInternalNotes] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    const [page, setPage] = useState(1);

    useEffect(() => {
        setPage(1);
        fetchRequests();
    }, [currentTab, selectedCity, searchQuery]);


    const fetchRequests = async () => {
        setIsLoading(true);
        try {
            const response = await getHelpRequests({ 
                status: currentTab, 
                city: selectedCity, 
                search: searchQuery 
            });

            // La ruta es: response.data (BaseController) -> data -> requests
            const data = response.data;
            
            setRequests(data.requests.data || []);
            setStats(data.stats || { pending: 0, verified: 0, delivered: 0 });

        } catch (error) {
            console.error("Error cargando solicitudes", error);
        } finally {
            setIsLoading(false);
        }
    };

    const handleUpdateStatus = async (newStatus) => {
        if (!selectedRequest) return;
        
        setIsSaving(true);
        
        try {
            const response = await updateRequestStatus(selectedRequest.id, { 
                status: newStatus, 
                internal_notes: internalNotes 
            });

            if (response.success) {
                // 1. CERRAR EL DRAWER PRIMERO
                setSelectedRequest(null);
                setInternalNotes("");
                
                // 2. ACTUALIZAR LA DATA
                // No esperamos a que la lista se cargue para cerrar el panel, 
                // la UI se siente mucho más rápida así.
                await fetchRequests(); 
            }
        } catch (error) {
            console.error("Error al actualizar estatus:", error);
            alert("Hubo un error al procesar el cambio.");
        } finally {
            setIsSaving(false);
        }
    };

    // Formateador sutil para las etiquetas de urgencia
    const getUrgencyStyles = (level) => {
        switch (level) {
            case "critica": return { color: "#d32f2f", bg: "rgba(211, 47, 47, 0.06)", label: "Crítica" };
            case "urgente": return { color: "#f57f17", bg: "rgba(245, 127, 23, 0.06)", label: "Urgente" };
            default: return { color: "#757575", bg: "#f5f5f5", label: "Preventiva" };
        }
    };

    

    return (
        <Container maxWidth='xl' sx={{mt:8, bgcolor: "fff" }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h4" sx={{ color: '#1a1a1a', fontWeight: 800, letterSpacing: -0.5 }}>
                        Módulo de Asistencia
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                        Gestión interna de solicitudes y asignación de apoyo comunitario.
                    </Typography>
                </Grid>
            </Grid>

            {/* 1. INDICADORES DE IMPACTO (Estilo Ticket Monocromático) */}
            <Grid container spacing={3} sx={{ mb: 5 }}>
                {[
                    { title: "CASOS PENDIENTES", count: stats.pending, icon: faClock, color: "#1a1a1a" },
                    { title: "CASOS VERIFICADOS", count: stats.verified, icon: faCheckCircle, color: "#1565c0" },
                    { title: "AYUDAS ENTREGADAS", count: stats.delivered, icon: faHandHoldingHeart, color: "#2e7d32" }
                ].map((stat, i) => (
                    <Grid item xs={12} sm={12} md={4} key={i}>
                        <Paper elevation={0} sx={{ p: 3, borderRadius: 4, border: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                            <Box>
                                <Typography variant="caption" sx={{ color: '#aaa', fontWeight: 700, letterSpacing: 0.5, display: 'block', mb: 0.5 }}>
                                    {stat.title}
                                </Typography>
                                <Typography variant="h3" sx={{ fontWeight: 800, color: stat.color, lineHeight: 1 }}>
                                    {stat.count}
                                </Typography>
                            </Box>
                            <Avatar sx={{ bgcolor: '#f9f9f9', color: stat.color, width: 48, height: 48, border: '1px solid #f0f0f0' }}>
                                <FontAwesomeIcon icon={stat.icon} size="sm" />
                            </Avatar>
                        </Paper>
                    </Grid>
                ))}
            </Grid>

            {/* SECCIÓN PRINCIPAL DE CONTROL */}
        
            <Paper elevation={0} sx={{ borderRadius: 4, border: '1px solid #f0f0f0', bgcolor: '#fff', overflow: 'hidden' }}>
    
    {/* FILTROS Y BÚSQUEDA - ESTRUCTURA GRID RESPONSIVA */}
<Box sx={{ 
    p: { xs: 2, sm: 3 }, 
    display: 'grid', 
    /* En móvil (xs) usa 1 sola columna. En escritorio (lg) usa 2 columnas. */
    gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'minmax(0, 1fr) auto' }, 
    gap: 2, 
    alignItems: 'center', 
    borderBottom: '1px solid #f0f0f0',
    width: '100%',
    boxSizing: 'border-box'
}}>
    
    {/* Pestañas de Estatus */}
    <Box sx={{ minWidth: 0, width: '100%' }}>
        <Tabs 
            value={currentTab} 
            onChange={(e, v) => setCurrentTab(v)} 
            variant="scrollable" 
            scrollButtons="auto"
            allowScrollButtonsMobile
            textColor="primary" 
            indicatorColor="primary"
            sx={{ 
                '& .MuiTab-root': { textTransform: 'none', fontWeight: 700, fontSize: '0.95rem' }
            }}
        >
            <Tab value="pending" label="Nuevas" />
            <Tab value="verified" label="Verificadas" />
            <Tab value="reinvestigate" label="En Reinvestigación" />
            <Tab value="delivered" label="Entregadas" />
            <Tab value="rejected" label="Archivadas" />
        </Tabs>
    </Box>

    {/* Inputs de Filtro */}
    <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
        <TextField
            select
            size="small"
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            sx={{ flex: 1, minWidth: 140 }}
            InputProps={{
                startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faFilter} color="#aaa" size="xs"/></InputAdornment>,
            }}
        >
            <MenuItem value="all">Todas las ciudades</MenuItem>
            <MenuItem value="Lechería">Lechería</MenuItem>
            <MenuItem value="Barcelona">Barcelona</MenuItem>
            <MenuItem value="Puerto La Cruz">Puerto La Cruz</MenuItem>
            <MenuItem value="Guanta">Guanta</MenuItem>
        </TextField>

        <TextField
            size="small"
            placeholder="Buscar por CI o Nombre..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{ flex: 1 }}
            InputProps={{
                startAdornment: <InputAdornment position="start"><FontAwesomeIcon icon={faSearch} color="#aaa" size="xs"/></InputAdornment>,
            }}
        />
    </Box>
</Box>

    {/* LISTADO DE CASOS */}
    <Box sx={{ p: 1 }}>
        {requests.length === 0 ? (
            <Typography variant="body2" sx={{ color: '#888', textAlign: 'center', py: 6 }}>
                No hay solicitudes que coincidan con los filtros seleccionados.
            </Typography>
        ) : (
            requests.map((req) => {
                const urgency = getUrgencyStyles(req.urgency_level);
                return (
                    <Box 
                        key={req.id}
                        onClick={() => { setSelectedRequest(req); setInternalNotes(""); }}
                        sx={{ 
                            display: 'flex', 
                            flexDirection: { xs: 'column', sm: 'row' }, /* Apila en móviles, fila en desktop */
                            alignItems: { xs: 'flex-start', sm: 'center' }, 
                            justifyContent: 'space-between',
                            gap: { xs: 2, sm: 1 },
                            p: 2.5, px: 3, borderRadius: 3, cursor: 'pointer',
                            transition: 'background-color 0.2s',
                            '&:hover': { bgcolor: '#f9f9f9' }
                        }}
                    >
                        {/* Lado Izquierdo (Info principal) */}
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2.5, minWidth: 0, width: { xs: '100%', sm: 'auto' } }}>
                            <Avatar sx={{ width: 42, height: 42, bgcolor: '#1a1a1a', color: '#fff', fontWeight: 700, fontSize: '0.9rem', flexShrink: 0 }}>
                                {req.applicant_name.charAt(0).toUpperCase()}
                            </Avatar>
                            <Box sx={{ minWidth: 0, flexGrow: 1 }}> {/* minWidth: 0 es clave para el textOverflow */}
                                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 0.3 }}>
                                    <Typography variant="subtitle1" noWrap sx={{ fontWeight: 700, color: '#1a1a1a', lineHeight: 1.2, maxWidth: '100%' }}>
                                        {req.applicant_name}
                                    </Typography>
                                    <Chip 
                                        label={urgency.label} 
                                        size="small" 
                                        sx={{ bgcolor: urgency.bg, color: urgency.color, fontWeight: 800, fontSize: '0.65rem', height: 20, borderRadius: 1 }} 
                                    />
                                    {req.is_third_party && (
                                        <Chip label="TERCERO" size="small" sx={{ bgcolor: '#eee', color: '#666', fontWeight: 700, fontSize: '0.6rem', height: 20, borderRadius: 1 }} />
                                    )}
                                </Box>
                                <Typography variant="body2" color="text.secondary" noWrap>
                                    C.I. {req.applicant_ci} • {req.city}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Lado Derecho (Insumos y Flecha) */}
                        <Box sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            justifyContent: { xs: 'space-between', sm: 'flex-end' }, 
                            gap: 2,
                            width: { xs: '100%', sm: 'auto' },
                            pl: { xs: 7.5, sm: 0 } /* En móviles, alinea los insumos con el texto, no con el avatar */
                        }}>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, justifyContent: { xs: 'flex-start', sm: 'flex-end' } }}>
                                {req.required_items.map((item, idx) => (
                                    <Chip key={idx} label={item} size="small" variant="outlined" sx={{ borderColor: '#e0e0e0', color: '#666', fontSize: '0.7rem', fontWeight: 600 }} />
                                ))}
                            </Box>
                            <IconButton size="small" sx={{ color: '#aaa', flexShrink: 0 }}>
                                <FontAwesomeIcon icon={faChevronRight} size="xs" />
                            </IconButton>
                        </Box>
                    </Box>
                );
            })
        )}
    </Box>
</Paper>

            {/* 3. MESA DE CONTROL LATERAL (DETALLE DEL CASO) */}
            <Drawer
                anchor="right"
                open={Boolean(selectedRequest)}
                onClose={() => setSelectedRequest(null)}
                PaperProps={{ sx: { width: { xs: '100%', sm: 480 }, p: 4, display: 'flex', flexDirection: 'column' } }}
            >
                {selectedRequest && (
                    <>
                        {/* Drawer Header */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 3 }}>
                            <Box>
                                <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a1a1a', letterSpacing: -0.5 }}>
                                    Detalle del Caso
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                    Registrado el {selectedRequest.created_at || 'Hoy'}
                                </Typography>
                            </Box>
                            <IconButton onClick={() => setSelectedRequest(null)} sx={{ color: '#aaa' }}>
                                <FontAwesomeIcon icon={faTimes} size="sm" />
                            </IconButton>
                        </Box>

                        <Divider sx={{ mb: 3, borderColor: '#f0f0f0' }} />

                        {/* Drawer Content */}
                        <Box sx={{ flexGrow: 1, overflowY: 'auto', pr: 1 }}>
                            
                            {/* Bloque: Solicitante */}
                            <Box sx={{ mb: 3.5 }}>
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', mb: 0.5 }}>Solicitante</Typography>
                                <Typography variant="body1" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>{selectedRequest.applicant_name}</Typography>
                                <Typography variant="body2" color="text.secondary">C.I. {selectedRequest.applicant_ci}</Typography>
                            </Box>

                            {/* Bloque Condicional: Terceros */}
                            {selectedRequest.is_third_party && (
                                <Box sx={{ mb: 3.5, p: 2, bgcolor: '#f9f9f9', borderRadius: 2, border: '1px solid #f0f0f0' }}>
                                    <Typography variant="caption" sx={{ color: '#f57f17', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', mb: 0.5 }}>Reporte de Tercero afectado</Typography>
                                    <Typography variant="body2" sx={{ color: '#1a1a1a', fontWeight: 500 }}>{selectedRequest.third_party_details}</Typography>
                                </Box>
                            )}

                            {/* Bloque: Logística de Contacto (Con el parche anti-undefined aplicado) */}
                            <Box sx={{ mb: 3.5 }}>
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', mb: 0.5 }}>Contacto y Ubicación</Typography>
                                <Typography variant="body2" sx={{ fontWeight: 700, color: '#1a1a1a', mb: 1 }}>{selectedRequest.city} — {selectedRequest.location}</Typography>
                                
                                <Button 
                                    variant="outlined" 
                                    size="small"
                                    startIcon={<FontAwesomeIcon icon={faWhatsapp} />}
                                    href={`https://wa.me/${selectedRequest.phone.replace('undefined', '').trim()}`}
                                    target="_blank"
                                    sx={{ color: '#25D366', borderColor: '#25D366', textTransform: 'none', fontWeight: 700, '&:hover': { bgcolor: 'rgba(37, 211, 102, 0.04)', borderColor: '#25D366' } }}
                                >
                                    Contactar por WhatsApp
                                </Button>
                            </Box>

                            {/* Bloque: Núcleo Familiar */}
                            <Grid container spacing={2} sx={{ mb: 3.5 }}>
                                <Grid item xs={6}>
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', mb: 0.5 }}>Carga Familiar</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#1a1a1a' }}>{selectedRequest.family_size} Personas</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', mb: 0.5 }}>Población Vulnerable</Typography>
                                    <Typography variant="body2" sx={{ fontWeight: 'bold', color: selectedRequest.has_vulnerable_population ? '#d32f2f' : '#1a1a1a' }}>
                                        {selectedRequest.has_vulnerable_population ? 'Sí (Niños/Ancianos)' : 'No'}
                                    </Typography>
                                </Grid>
                            </Grid>

                            {/* Bloque: Insumos Solicitados */}
                            <Box sx={{ mb: 3.5 }}>
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', mb: 0.5 }}>Ayuda Requerida</Typography>
                                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 0.5, mb: selectedRequest.medical_details ? 1 : 0 }}>
                                    {selectedRequest.required_items.map((item, idx) => (
                                        <Chip key={idx} label={item} size="small" sx={{ bgcolor: '#1a1a1a', color: '#fff', fontWeight: 700, fontSize: '0.7rem' }} />
                                    ))}
                                </Box>
                                {selectedRequest.medical_details && (
                                    <Typography variant="body2" sx={{ bgcolor: '#fff8e1', color: '#b78103', p: 1.5, borderRadius: 2, fontSize: '0.85rem', fontWeight: 500, mt: 1 }}>
                                        <strong>Especificación médica:</strong> {selectedRequest.medical_details}
                                    </Typography>
                                )}
                            </Box>

                            {/* Notas del Supervisor Interno */}
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', mb: 1 }}>
                                    Historial de Validación
                                </Typography>

                                <Box sx={{ mb: 3 }}>
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', mb: 1 }}>
                                        Historial de Validación
                                    </Typography>
                                    
                                    <Box sx={{ maxHeight: '350px', overflowY: 'auto'}}>
                                        {Array.isArray(selectedRequest.internal_notes) ? (
                                            selectedRequest.internal_notes.map((log, index) => (
                                                <Paper key={index} elevation={0} sx={{ p: 1.5, mb: 1, bgcolor: '#f4f6f8', borderRadius: 2 }}>
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 0.5 }}>
                                                        <Typography variant="caption" sx={{ fontWeight: 800, color: '#1565c0' }}>
                                                            {log.user_name || 'Supervisor'}
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: '#94a3b8' }}>{log.timestamp}</Typography>
                                                    </Box>
                                                    <Typography variant="body2">{log.note}</Typography>
                                                </Paper>
                                            ))
                                        ) : (
                                            <Typography variant="body2" color="text.secondary">No hay notas previas.</Typography>
                                        )}
                                    </Box>
                                </Box>

                                {/* 2. CAMPO DE ESCRITURA (Nuevo comentario) */}
                                <Box sx={{ mb: 2 }}>
                                    <Typography variant="caption" sx={{ color: '#64748b', fontWeight: 'bold', textTransform: 'uppercase', display: 'block', mb: 1 }}>
                                        Nueva Nota
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        multiline
                                        rows={3}
                                        placeholder="Escribe aquí tu observación sobre este cambio de estado..."
                                        value={internalNotes} // ESTO DEBE SER UN STRING, NO UN OBJETO
                                        onChange={(e) => setInternalNotes(e.target.value)}
                                        sx={{ 
                                            '& .MuiOutlinedInput-root': { borderRadius: 2 },
                                            bgcolor: '#fff' 
                                        }}
                                    />
                                </Box>
                            </Box>
                        </Box>

                        <Divider sx={{ my: 2, borderColor: '#f0f0f0' }} />

                        {/* Drawer Actions: Botonera Dinámica según la pestaña */}
                        <Box sx={{ display: 'flex', gap: 2 }}>
                            {selectedRequest.status === "pending" && (
                                <>
                                    <Button 
                                        flex={1} fullWidth variant="outlined" color="error" disabled={isSaving}
                                        sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2.5 }}
                                        onClick={() => handleUpdateStatus('rejected')}
                                    >
                                        Rechazar / Archivar
                                    </Button>
                                    <Button 
                                        flex={1} fullWidth variant="contained" color="primary" disableElevation disabled={isSaving}
                                        sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2.5, bgcolor: '#1565c0' }}
                                        onClick={() => handleUpdateStatus('verified')}
                                    >
                                        Marcar Verificado
                                    </Button>
                                </>
                            )}
                            {selectedRequest.status === "verified" && (
                                <Button 
                                    fullWidth variant="contained" color="success" disableElevation disabled={isSaving}
                                    sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2.5, bgcolor: '#2e7d32', '&:hover': { bgcolor: '#1b5e20' } }}
                                    onClick={() => handleUpdateStatus('delivered')}
                                >
                                    Confirmar Entrega de Ayuda
                                </Button>
                            )}
                            {selectedRequest.status === 'verified' && (
                                <Button 
                                    variant="outlined" 
                                    color="warning" 
                                    fullWidth
                                    onClick={() => handleUpdateStatus('reinvestigate')}
                                    sx={{ py: 1.5, borderRadius: 2 }}
                                >
                                    Reinvestigar Caso
                                </Button>
                            )}
                            {(selectedRequest.status === "delivered" || selectedRequest.status === "rejected") && (
                                <Button 
                                    fullWidth variant="outlined" color="inherit"
                                    sx={{ textTransform: 'none', fontWeight: 700, borderRadius: 2.5, borderColor: '#e0e0e0' }}
                                    onClick={() => handleUpdateStatus('pending')}
                                >
                                    Reabrir e Investigar Caso
                                </Button>
                            )}
                        </Box>
                    </>
                )}
            </Drawer>
        </Container>
    );
}